import * as React from 'react'
import { InputLabel, Grid, Tooltip, Icon } from '@mui/material'

export const EditInputsWrap = ({
  children,
  label,
  tooltiptext,
  required,
  disabled,
  className = '',
  xs,
  md,
  lg,
  style
}) => {
  let defaultXS = xs ? xs : 12
  let defaultMD = md ? md : 4
  let defaultLG = lg ? lg : false
  return (
    <Grid item xs={defaultXS} md={defaultMD} lg={defaultLG} className={`editInputsWrap ${className}`} style={style}>
      <div className='labelBloq'>
        <InputLabel className='label' required={required} disabled={disabled}>
          {label ? label : '\u00a0\u00a0'}
        </InputLabel>
        {tooltiptext && (
          <Tooltip title={tooltiptext} className='tooltip' placement='top'>
            <Icon>info</Icon>
          </Tooltip>
        )}
      </div>
      {children}
    </Grid>
  )
}
